<template>
  <div class="main" ref="content">
    <nav class="nav flex" ref="nav">
      <span v-for="(item,i) in navs" :class="curNav==i?'cur':''" :key="i" @click="curNav=i">{{item}}</span>
    </nav>
    <div class="content" v-show="curNav==0">
      <TodaySouthAmount />
      <HistorySouthAmount />
      <HistorySouthData />
    </div>
    <div class="content" v-show="curNav==1">
      <GgtGeGu />
    </div>
  </div>
</template>

<script>
import TodaySouthAmount from './TodaySouthAmount.vue'
import HistorySouthAmount from './HistorySouthAmount.vue'
import HistorySouthData from './HistorySouthData.vue'
import GgtGeGu from './GgtGeGu.vue'

export default {
  name: 'GangGuTong',
  components: {
    TodaySouthAmount,
    HistorySouthAmount,
    HistorySouthData,
    GgtGeGu,
  },
  props: {
    msg: String
  },
  data () {
    return {
      curNav:0,
      navs:['资金概况','十大成交股'],
    }
  },
  filters:{
    formateTag:function(v){
      if(v==undefined||v==null) return
      if(v>0) return '交易中'
      if(v<0) return '已结束'
    },
    formatePrefixData:function(v) {
      if(v==undefined||v==null) return '--'
      if(v>0) return '+'+v
      if(v<0) return v 
    },
    formateRedGreen:function (v) {
      if(v==undefined||v==null) return
      if(v>0) return 'ft-red'
      if(v<0) return 'ft-green'
    }
  },
  mounted:function(){
    this.scrollFixed()
  },
  methods:{
    scrollFixed:function () {
      var ot = this.$refs.content.offsetTop
      var bar = this.$refs.nav
      window.onscroll = function(){ 
        var st = document.documentElement.scrollTop
        console.log(st,ot)
        if(st > ot){
          bar.classList.add("fixed")
        }else{
          bar.classList.remove("fixed")
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
